import { getTranslation } from "Utils/getTranslation"
import { getLangageIdFromNavigator } from "Utils/global"
import { createSelector } from "reselect"

const login = state => state.login

//User information
export const selectCurrentUser = createSelector([login], login => login.userConnected)

export const selectLangageID = createSelector(
  [selectCurrentUser, login],
  (selectCurrentUser, loginState) => {
    const explicitLanguage = selectCurrentUser?.LANGUAGE_ID
    if (explicitLanguage !== undefined && explicitLanguage !== null) return explicitLanguage

    if (typeof loginState?.languageLogin === "number") {
      return loginState.languageLogin
    }

    try {
      return getLangageIdFromNavigator()
    } catch (error) {
      return 0
    }
  }
)

export const selectTranslation = createSelector([selectLangageID], selectLangageID => {
  return getTranslation(selectLangageID)
})

export const selectCurrentUserId = createSelector(
  [selectCurrentUser],
  userConnected => userConnected.USER_ID
)

export const selectCurrentFirstNameUser = createSelector(
  [selectCurrentUser],
  userConnected => userConnected.FIRSTNAME
)

export const selectCurrentUserBusinessID = createSelector(
  [selectCurrentUser],
  userConnected => userConnected.BUSINESS_ID
)

export const selectCurrentUserRoleID = createSelector(
  [selectCurrentUser],
  userConnected => userConnected.BUSINESS_ROLE
)

export const selectCurrentToken = createSelector([login], login => login.jwt)
// export const selectCurrentToken = createSelector([login], login =>
//   localStorage.getItem("accessToken")
// )

export const selectIsMultiBusiness = createSelector([login], login => login.isMultiBusiness)
export const selectInfosMultiBusiness = createSelector([login], login => login.infosMultiBusiness)

export const selectMfaChallenge = createSelector([login], login => login.mfaChallenge)
